import { render, staticRenderFns } from "./doughnut-chart-card.vue?vue&type=template&id=428f4ea3&scoped=true"
import script from "./doughnut-chart-card.vue?vue&type=script&lang=js"
export * from "./doughnut-chart-card.vue?vue&type=script&lang=js"
import style0 from "./doughnut-chart-card.vue?vue&type=style&index=0&id=428f4ea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428f4ea3",
  null
  
)

export default component.exports